import { useHistory } from "react-router-dom";
import HeaderReportMp from "../../../../Components/ComponentsMarketplace/HeaderReportMp";
import BootonsMap from "../../../../Components/ComponentsMarketplace/ButtonsMap";
import { useSausage } from "../../../../providers/SausageContext"
import { useState, useEffect } from "react";

import {
  Container,
  SizeContainer,
  ContainerCard,
  InternalMenu,
  Confirm
} from "./style";

const MpStockSausage = () => {
  const history = useHistory()

  const { infoSausage, stockSausageMarket, getSausageStockMp } = useSausage()

  const [ quantidade, setQuantidade ] = useState(0),
  [ preco, setPreco ] = useState(0)
  

  useEffect(() => {
 
    setPreco(infoSausage?.custoUnitario)
    setQuantidade(stockSausageMarket)  

  },[infoSausage, stockSausageMarket])

  useEffect(() => {
    getSausageStockMp()
  })

  return (
    <Container>
      <SizeContainer>
        <HeaderReportMp title="Estoque" pathImg="./images/stock_Mp.svg" />
        <InternalMenu>
          <button className='selected' ><img src="./images/sausage_orange.svg" alt="sausage"/></button>
          <button onClick={() => history.push('/mpStockChicken')} ><img src="./images/chicken_orange.svg" alt="chicken"/></button>
          <button onClick={() => history.push('/mpStockChickenCut')}><img src="./images/chicken_cut_orange.svg" alt="chicken cut"/></button>
          <button onClick={() => history.push('/mpStockFries')}><img src="./images/fries_orange.svg" alt="fries"/></button>
        </InternalMenu>
        <ContainerCard>
          <div>
            <p>Quantidade</p>
            <small>{quantidade}</small>
          </div>
          <p>X</p>
          <div>
            <p>Custo médio</p>
            <small>{preco}</small>
          </div>
          <div>
            <p>Valor do estoque</p>
            <small>{preco*quantidade}</small>
          </div>
        </ContainerCard>
        <BootonsMap />
        <Confirm>Comprar</Confirm>
      </SizeContainer>
    </Container>
  );
};
export default MpStockSausage;
